export const DEBOUNCE_TIME_TO_START_SEARCH = 1000;
